import {ReactElement} from 'react';

import {Container} from '@mui/material';

interface Props {
  children: ReactElement | ReactElement[];
}

export const PageContainer = ({children}: Props) => {
  return (
    <Container id='main' maxWidth='lg' sx={{mb: 10}}>
      {children}
    </Container>
  );
};
